/**
 * Auto-generated file created by svgr-cli source svgr.template.config.js
 * Run yarn svgr to update
 * Do not edit
 */
import * as React from 'react'
import { SVGProps, memo } from 'react'
const SvgDownload = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 24}
    height={props.height || 24}
    fill="currentColor"
    viewBox="0 0 16 16"
    color={props.color || '#EE4D2D'}
    {...props}
  >
    <path
      fill="currentColor"
      d="M1.5 14a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5v-3.334a.5.5 0 0 0-1 0v2.833h-11v-2.833a.5.5 0 0 0-1 0v3.333Z"
    />
    <path
      fill="currentColor"
      d="M11.687 7.686a.5.5 0 0 0-.707-.707L8.5 9.46V2.666a.5.5 0 1 0-1 0v6.793l-2.48-2.48a.5.5 0 1 0-.707.707l3.333 3.334a.5.5 0 0 0 .707 0l3.334-3.334Z"
    />
  </svg>
)
const Memo = memo(SvgDownload)
export default Memo
